import axios from "axios";
import { GENERAL_URL_API } from "../../components/Store";
import { SesionAPI } from "./Sesion";

const validateAndCreate = async ({ abortSignal, data }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		const serialzed = {
			correo: data.email,
			password: data.password,
			codigo: data.code,
			mayorDeEdad:data?.isLegalAge ? 1 : 0
		};
		Object.keys(serialzed).forEach((key) => {
			formData.append(key, serialzed[key]);
		});
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/crearCuenta`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			console.log("Account created successfully", data.email);
		} else {
			return Promise.reject({ code: response?.data?.info || "Error creating account" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

const sendConfirmationCode = async ({ abortSignal, data }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("correo", data?.email);
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/crearCodigoConfirmacion`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			console.log("email confirmation code sent successfully to", data?.email);
		} else {
			return Promise.reject({
				code: response?.data?.info || "Error sending email confirmation code",
			});
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

const resendConfirmationCode = async ({ abortSignal, data }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("correo", data?.email);
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/reenviarCodigo`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			console.log("email confirmation code resend successfully to", data?.email);
		} else {
			return Promise.reject({
				code: response?.data?.info || "Error resending email confirmation code",
			});
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
const sendWelcomeEmail = async ({ abortSignal, data }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("email", data?.email);
		formData.append("password", data?.password);
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/enviarCorreoBienvenida`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			console.log("welcome email sent successfully to", data?.email);
		} else {
			return Promise.reject({
				code: response?.data?.info || "Error sending welcome email",
			});
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

const updateProfileData = async (props) => {
	const { abortSignal = null, data } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		// res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("nombreCompleto", data?.fullname);
		formData.append("pais", data?.country !== 'OTRO'? data?.country: data?.other_country || data?.country );
		formData.append("celular", data?.phoneNumber);
		if (typeof data?.newsletter === "boolean") {
			formData.append("boletin", data?.newsletter ? 1 : 0);
		}
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/editarPerfil`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			console.log("profile data updated successfully", data);
		} else {
			return Promise.reject({ code: response?.data?.info || "Error updating profile data" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};
const updateProfilePassword = async (props) => {
	const { abortSignal = null, data } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		// res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("prevPass", data?.currentPassword);
		formData.append("newPass", data?.newPassword);
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/editarPassword`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			console.log("profile data updated successfully", data);
		} else {
			return Promise.reject({ code: response?.data?.info || "Error updating profile data" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

const getUserProfileData = async (props) => {
	const { abortSignal = null } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		// res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/obtenerDatos`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
		});
		if (response.status === 200 && !!response?.data?.makemakeData) {
			const responseData = response?.data?.makemakeData;
			const institutions = Array.isArray(responseData?.instituciones)
				? responseData?.instituciones
				: []

			const profileData = {
				username: responseData?.correo,
				fullname: responseData?.nombre,
				email: responseData?.correo,
				country: responseData?.pais,
				phoneNumber: responseData?.celular,
				institutions: institutions.map((institution) => ({
					index: institution?.index,
					email:institution?.correo,
					logo: institution?.logo,
					name: institution?.nombre,
					status: institution?.estado,
					booksLength: institution?.cantidadLibros,
					suscriptionDate: institution?.fechaFinSuscripcion,
					website: institution?.link,
					current: institution?.enUso === 1 ? true: false
				})),
			};
			return profileData;
		} else {
			return Promise.reject({ code: response?.data?.info || "Error loading profile data" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

const authUser = async (props) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		const { abortSignal = null, data } = props;
		await SesionAPI.cerrarSesion({ abortSignal });
		await SesionAPI.defaultSignIn({
			abortSignal,
			data: { username: data.email, password: data.password },
		});
		console.log("logout and user authenticated!", data.email);
		return Promise.resolve(true);
	} catch (error) {
		return Promise.reject({ code: error?.data?.info || "auth-error" });
	}
};

const setCurrentInstitution = async (props) => {
	const { abortSignal = null, data } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("instituteIndex", data?.institutionIndex);
		formData.append("nombreInstituto", data?.institutionName);

		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/cambiarInstituto`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		const responseData = response?.data?.cambioData;
		console.log(responseData)
		if (response.status === 200 && responseData?.status === 1) {
			console.log("Institution changed successfully!", responseData);
		} else {
			return Promise.reject({ code: responseData?.info || "Error changing institution" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};


const removeInstitution = async (props) => {
	const { abortSignal = null, data } = props;
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("instituteIndex", data?.institutionIndex);
		formData.append("nombreInstituto", data?.institutionName);

		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/eliminarInstituto`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		const responseData = response?.data;
		if (response.status === 200 && responseData?.status === 1) {
			console.log("Institution removed successfully!");
		} else {
			return Promise.reject({ code: responseData?.info || "Error removing institution" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};


const sendInstitutionRenovationEmail = async (props) => {
		const { abortSignal = null, data } = props;
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("institute", data?.institutionName);
		formData.append("client", data?.client);

		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/notificarInstitutoVencido`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		const responseData = response?.data;
		if (response.status === 200 && responseData?.status === 1) {
			console.log("renovation email sent successfully!");
		} else {
			return Promise.reject({ code: responseData?.info || "Error sending renovation email" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

const defaultSignIn = async (props) => {
	const { abortSignal = null, data } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;
	
		const formData = new FormData();
		formData.append("usuarioInstituto", data?.username);
		formData.append("passwordInstituto", data?.password);
	
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/asociarInstitutoCredenciales`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		const responseData = response?.data;
		if (response.status === 200 && responseData?.status === 1) {
			console.log("The institution was linked successfully.");
		} else {
			return Promise.reject({ code: responseData?.info || "Failed to link the institution." });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};
const alternativeSignIn = async (props) => {
	const { abortSignal = null, data } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, credenciales del usuario individual inválidas'})
	// 		// res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;
	
		const formData = new FormData();
		formData.append("usuarioIndividual", data?.username);
		formData.append("passwordIndividual", data?.password);
	
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/asociarClienteInstitutoCredenciales`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		const responseData = response?.data;
		if (response.status === 200 && responseData?.status === 1) {
			console.log("The institution was linked successfully.");
		} else {
			return Promise.reject({ code: responseData?.info || "Failed to link the institution." });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};
const generateAccessToken = async (props) => {
	const { abortSignal = null } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		// res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;
	
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/generarTokenAsociacion`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
		});
		const responseData = response?.data;
		if (response.status === 200 && responseData?.status === 1) {
			console.log("Access token generated successfully.");
			return responseData?.token || '';
		} else {
			return Promise.reject({ code: responseData?.info || "Failed to generate access token." });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};


const validateAndConnectByToken = async (props) => {
	const { data, abortSignal = null } = props;
	// 	return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, no tienes acceso a editar perfiles'})
	// 		res(true)
	// 	}, 1000)
	// })
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("token", data?.token);

		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/asociarInstitutoToken`,
			signal: abortSignal || null,
			headers: { "Content-Type": "multipart/form-data" },
			data: formData,
		});
		const responseData = response?.data;
		if (response.status === 200 && responseData?.status === 1) {
			console.log("The institution was linked successfully.");
			return responseData?.token || '';
		} else {
			return Promise.reject({ code: responseData?.info || "Failed to link the institution." });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

const InstitutionConnection = {
	defaultSignIn,
	generateAccessToken,
	validateAndConnectByToken,
	alternativeSignIn
}


export const PersonalAccountAPI = {
	validateAndCreate,
	sendConfirmationCode,
	sendWelcomeEmail,
	updateProfileData,
	updateProfilePassword,
	authUser,
	resendConfirmationCode,
	getUserProfileData,
	setCurrentInstitution,
	removeInstitution,
	sendInstitutionRenovationEmail,
	InstitutionConnection
};
